/* eslint-disable */
import React from "react";
import { Modal, Backdrop } from "@material-ui/core";
import MuiFade from "@material-ui/core/Fade";
import { makeStyles } from "@material-ui/core/styles";

// parseHexColor.js
export function parseHexColor(hexColor) {
  // hexColor precisa começar com '#'
  // Ex.: #RRGGBB ou #RRGGBBAA
  // Se o alpha não for encontrado, assume 100%.
  // Exemplo de input: "#FF00001A" -> #FF0000 (vermelho) e alpha 1A (hex) => ~0.102

  // Se não tiver "#", ou for muito curto, retorne algo default
  if (
    !hexColor ||
    !hexColor.startsWith("#") ||
    (hexColor.length !== 7 && hexColor.length !== 9)
  ) {
    return "rgba(0,0,0,1)"; // fallback
  }

  // Extrair R, G, B
  const r = parseInt(hexColor.substring(1, 3), 16);
  const g = parseInt(hexColor.substring(3, 5), 16);
  const b = parseInt(hexColor.substring(5, 7), 16);

  let a = 1; // alpha default
  // Se tiver 9 caracteres (# + RRGGBBAA = 9)
  if (hexColor.length === 9) {
    const alphaHex = hexColor.substring(7, 9);
    a = parseInt(alphaHex, 16) / 255;
  }

  // Retorna a string "rgba(r,g,b,a)"
  return `rgba(${r}, ${g}, ${b}, ${a.toFixed(3)})`;
}

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(2, 4, 3),
    maxHeight: "80vh",
    overflowY: "auto",
    borderRadius: "10px",
  },
  sectionList: {
    listStyle: "none",
    padding: 0,
    margin: 0,
  },
  // Recebe 'props' para pegar clientColor
  sectionListItem: (props) => {
    // Conversion to RGBA, ex.: "#FF00001A" => "rgba(255,0,0,0.1)"
    const baseColorRgba = parseHexColor(props.clientColor);

    const hoverRgba = baseColorRgba.replace(
      /(\d?\.?\d+)\)$/,
      () => "0.1)" // <= defina aqui o alpha que quiser
    );

    return {
      padding: theme.spacing(1),
      borderBottom: `1px solid ${baseColorRgba}`,
      cursor: "pointer",
      "&:hover": {
        backgroundColor: hoverRgba,
      },
    };
  },
}));

export default function EditSectionModal({
  open,
  handleClose,
  sections,
  setSelectedSectionId,
  clientColor,
}) {
  const classes = useStyles({ clientColor });

  const handleSectionClick = (id) => {
    setSelectedSectionId(id);
    handleClose();
  };

  return (
    <Modal
      className={classes.modal}
      open={open}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{ timeout: 500 }}
    >
      <MuiFade in={open}>
        <div className={classes.paper}>
          <h3>Selecionar Seção</h3>
          <ul className={classes.sectionList}>
            {sections.map((section) => (
              <li
                key={section.id}
                className={classes.sectionListItem}
                onClick={() => handleSectionClick(section.id)}
              >
                {section.section_name}
              </li>
            ))}
          </ul>
        </div>
      </MuiFade>
    </Modal>
  );
}
